//utils
const NotFound = () => import('@/views/404.vue')
const Files = () => import('@/views/Files.vue')

export default [
  {
    path: '/files',
    component: Files
  },
  {
    path: '*',
    name: "404",
    component: NotFound
  },
]